// Do not edit.
import { ShaderStore } from "../../Engines/shaderStore.js";
var name = "boundingBoxRendererFragmentDeclaration";
var shader = "uniform vec4 color;\n";
// Sideeffect
ShaderStore.IncludesShadersStore[name] = shader;
/** @hidden */
export var boundingBoxRendererFragmentDeclaration = { name: name, shader: shader };
//# sourceMappingURL=boundingBoxRendererFragmentDeclaration.js.map